import { render, staticRenderFns } from "./UploadSelectedMemberDocument.vue?vue&type=template&id=63b939ce"
import script from "./UploadSelectedMemberDocument.vue?vue&type=script&lang=js"
export * from "./UploadSelectedMemberDocument.vue?vue&type=script&lang=js"
import style0 from "./UploadSelectedMemberDocument.vue?vue&type=style&index=0&id=63b939ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports